import React from 'react';
interface AvatarProps {
  src: string;
  alt: string;
  isOnline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Avatar({
  src,
  alt,
  isOnline = false,
  size = 'md',
  className = ''
}: AvatarProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };
  return <div className={`relative inline-block ${sizeClasses[size]} ${className}`} data-id="element-350">
      <img src={src} alt={alt} className="h-full w-full rounded-full object-cover border border-border" data-id="element-351" />
      {isOnline && <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-500 ring-2 ring-white" data-id="element-352" />}
    </div>;
}